import Layout from "../../components/Layout";
import NextHead from "../../components/Seo/NextHead";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { RewardsBreadCrumb } from "../../data/DataBreadcrumb";
import { rewardsMeta } from "../../data/DataMetatags";
import Reward from "../../components/Rewards/Reward";
import { defBreadcrumb } from "../../data/DataBreadcrumb";
import { useEffect } from "react";
import { GACustomEvent } from "src/utils/analytics";

const Rewards = (props) => {
  const {
    codename,
    breadcrumb,
    RewardsBreadCrumb,
    title,
    description,
    path
  } = props;

  useEffect(() => {
    GACustomEvent("rewards_page", "view");
  }, []);

  return (
    <Layout>
      <NextHead
        title={title}
        url={path}
        description={description}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={RewardsBreadCrumb} />
      <Reward rewardBanners={codename} />
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = rewardsMeta;
  const codename = "rewards_slider";
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: {
      codename,
      breadcrumb,
      RewardsBreadCrumb,
      title,
      description,
      path
    }
  };
};

export default Rewards;
